import { Tooltip } from "@material-ui/core";
import React, { PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  title: string | JSX.Element;
  open?: boolean;
}>;

export function WarningTooltip({ title, open = false, children }: Props) {
  if (!children) {
    return null;
  }

  return (
    <Tooltip
      classes={{
        // TODO (lsanwick) Migrate to design system Tooltip, adding sentiments
        tooltip: "cw-bg-warning cw-body-base cw-text-warning",
      }}
      title={title}
      open={open}
      placement="bottom"
    >
      {/* Cast because MUI type for children does not match React :-( */}
      {children as React.ReactElement}
    </Tooltip>
  );
}
